/* eslint-disable no-template-curly-in-string */
import yup from 'schemas/validation/feature'
import strings from 'utils/strings'
import { isUndefined } from 'utils/types'
import { QUERY_BOX_TYPES, TIMER } from 'utils/constants'
import conditionSchema from './conditionSchema'

import { isDefinedCondition, isOrphan } from './utils'

const querySchema = yup
  .object({
    queryType: yup.string(),
    description: yup
      .string()
      .nullable()
      .when('queryType', {
        is: (value) =>
          (value && QUERY_BOX_TYPES.has(value)) || isUndefined(value),
        then: yup.string().required().unique().max(80),
      }),
    initialValue: yup
      .number()
      .nullable()
      .when('queryType', {
        is: (value) => value === TIMER,
        then: yup.number().required(),
      }),
    conditions: yup.array().of(conditionSchema),
    delayActivate: yup.number().nullable(), // TODO: validate? timer input field should prevent unavailable numbers
    delayDeactivate: yup.number().nullable(),
  })
  // test for enable or any condition (for complex) is defined
  // when the query is not an orphan
  .test({
    name: 'required',
    test: function test(value) {
      const { parent, path } = this
      const { uri, queryType, conditions } = value

      // if not at parent, we know it's being used as a rule (in component)
      // if not complex/timer then doesn't matter
      // if it is an orphan, then we don't want to validate
      if (!parent || !QUERY_BOX_TYPES.has(queryType) || isOrphan(uri, this))
        return true

      // find enable timer and set error if it is invalid
      if (queryType === TIMER) {
        const enableCondition = conditions[0]
        const valid = isDefinedCondition(enableCondition)

        return (
          valid ||
          this.createError({
            path: `${path}.conditions[0].signalOrFloatingCircuit`,
            message: strings.activate_condition_validation, // not user facing
          })
        )
      }

      // if there is not condition set on complex query, set error on first condition
      const hasSignal = conditions.some((condition) => {
        return isDefinedCondition(condition)
      })

      if (hasSignal) return true

      // if we don't find a signal, set error on first condition
      return this.createError({
        path: `${path}.conditions[0].signalOrFloatingCircuit`,
        message: strings.one_condition_validation, // not user facing
      })
    },
  })

export default querySchema
